import { coreApi } from "./coreApi";

export const commissionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getCommissions: builder.query({
      query: () => ({
        url: "/administrator/commissions",
        method: "GET",
      }),

      providesTags: ["Commissions"],
    }),
    getSpecificCommissions: builder.query({
      query: (commissionId) => ({
        url: `/administrator/commissions/show/${commissionId}`,
        method: "GET",
      }),
    }),
    getAllCommissionsRules: builder.query({
      query: () => ({
        url: "/administrator/commissions/rules",
        method: "GET",
      }),
    }),
    getSpecificCommissionsRule: builder.query({
      query: (ruleId) => ({
        url: `/administrator/commissions/rules/show/${ruleId}`,
        method: "GET",
      }),
    }),
    createCommissionRule: builder.mutation({
      query: (rule) => ({
        url: "/administrator/commissions/rules/store",
        method: "POST",
        body: rule,
      }),
    }),
    updateCommissionRule: builder.mutation({
      query: (commissionId, NewData) => ({
        url: `administrator/commissions/rules/update/${commissionId}`,
        method: "POST",
        body: NewData,
      }),
    }),
    getAllCommissionsLogs: builder.query({
      query: () => ({
        url: "/administrator/commissions/logs",
        method: "GET",
      }),
    }),
    getAllCommissionsWithStores: builder.query({
      query: () => ({
        url: "/administrator/commissions/rules/create",
        method: "GET",
      }),
    }),
    getLogForSpecificCommission: builder.query({
      query: (commissionId) => ({
        url: `/administrator/commissions/logs/show/${commissionId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCommissionsQuery,
  useGetSpecificCommissionsQuery,
  useGetSpecificCommissionsRuleQuery,
  useGetAllCommissionsRulesQuery,
  useLazyGetAllCommissionsRulesQuery,
  useCreateCommissionRuleMutation,
  useUpdateCommissionRuleMutation,
  useGetAllCommissionsLogsQuery,
  useGetAllCommissionsWithStoresQuery,
  useGetLogForSpecificCommissionQuery,
} = commissionsApi;
